function toHex(buffer: ArrayBuffer) {
    return Array.from(new Uint8Array(buffer))
        .map((b) => b.toString(16).padStart(2, "0"))
        .join("");
}

function fromHex(hex: string) {
    const bytes = new Uint8Array(hex.length / 2);
    for (let i = 0; i < bytes.length; i += 1) {
        bytes[i] = parseInt(hex.slice(i * 2, i * 2 + 2), 16);
    }
    return bytes;
}

async function getKey(secret: string) {
    const encoded = new TextEncoder().encode(secret);
    const hash = await crypto.subtle.digest("SHA-256", encoded);
    return crypto.subtle.importKey("raw", hash, { name: "AES-CBC" }, false, ["encrypt"]);
}

export async function encryptText(plainText: string, secret: string) {
    const key = await getKey(secret);
    const iv = crypto.getRandomValues(new Uint8Array(16));
    const encrypted = await crypto.subtle.encrypt(
        { name: "AES-CBC", iv },
        key,
        new TextEncoder().encode(plainText)
    );
    return `${toHex(iv.buffer)}:${toHex(encrypted)}`;
}

export function lastFourOf(value: string) {
    return value.slice(-4);
}

export function normalizeDigits(value: string) {
    return value.replace(/\s+/g, "");
}

